import { SET_ASSIGNEES_REQUESTS } from 'root/src/client/logic/project/actionIds'
import { apiStoreLenses } from 'root/src/client/logic/api/lenses'

const {	setLiveAssigneesRequests } = apiStoreLenses

export default {
	[SET_ASSIGNEES_REQUESTS]: (state, payload) => setLiveAssigneesRequests(payload, state),
}
